import React from 'react';
import { Form, Segment, Button, Modal, Label } from 'semantic-ui-react';
import { headers, BaseURLDev } from '../../../../../_utils/config';
import swal from 'sweetalert';

export default class ModalAdd extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               "nama_bank": "",
               "kode_akun": "",
               "nama_akun": "",
               "keterangan": "",
            },

         loading:false,
         error:false,

      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.handleKeyPress = this.handleKeyPress.bind(this)
   }

   handleKeyPress(event){
      if(event.key === '/' || event.key === '%' || event.key === "'" || event.key === '"'){
         swal("Maaf, penggunaan spesial karakter (\", ', %, /) pada isian nama atau keterangan diblock", {
            icon: "warning",
         });
      }
   }
   
   onSubmit(e){
      const { kode, nama, keterangan } = this.state.data;
      this.setState({loading:true});
      e.preventDefault();
      if((kode===null || kode==="") || (nama===null || nama==="")){
         this.setState({loading:false,error:true});
         swal("Data Kode Bank/Nama Bank harus diisi", {
            icon: "error",
         });
         return false;
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/rekening_bank`,{
            method: 'POST',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
               swal("", "Simpan data Rekening Bank gagal", "error");
                  this.setState({loading:false,error:true});
                  return Promise.reject(response.statusText);
               }
            else{
               this.setState({
                  loading:false,
                  error:false,
                  data:{
                     "nama_bank": "",
                     "kode_akun": "",
                     "nama_akun": "",
                     "keterangan": ""
                  }
               });
               swal("Data Rekening Bank berhasil disimpan",{icon:"success"}).then(()=>{
                  window.location.href = '/b/bank';
               })
            }
         })
      }
   }

   onChange(e){
      let text = e.target.value.replace(/['/%"]/g, '')
      this.setState({data:{...this.state.data, [e.target.name]:text}});
   }

   render() {
      const {nama_bank, nama_akun,kode_akun,keterangan} = this.state.data;
      const {loading} = this.state;
      
      return (
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="small"
            >
               <Modal.Header>
                  Tambah data Rekening Bank
               </Modal.Header>
               
               <Modal.Content scrolling>
                  <Segment padded>
                     <Label attached='top' color="violet">Form Tambah data Rekening Bank</Label>
                     <Form onSubmit={this.onSubmit} loading={loading}>              
                        <Form.Input value={nama_bank} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="nama_bank" title="Nama Bank" placeholder="Misal: Bank BSI"/>
                        <Form.Input value={nama_akun} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="nama_akun" title="Nama Akun Bank" placeholder="Nama Akun Bank"/>
                        <Form.Input value={kode_akun} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="kode_akun" title="Kode Akun Bank" placeholder='Kode Akun Bank' />               
                        <Form.Input value={keterangan} onKeyPress={this.handleKeyPress} onChange={this.onChange} name="keterangan" title="keterangan bank" placeholder='Keterangan' />               
                        <Form.Button positive>Simpan</Form.Button>
                     </Form>
                  </Segment>
               </Modal.Content>
               <Modal.Actions>
                  <Button negative onClick={this.props.onClose}>Tutup</Button>                        
               </Modal.Actions>
            </Modal>                      
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_bank/ModalAdd.js